import * as UI from "@iyk/ui"
import * as React from "react"

import { useIntersection } from "../ui/use-intersection.ts"
import { Hero } from "./hero.tsx"
import { Tagline, type TaglineContent } from "./tagline.tsx"
import { SectionLayout } from "./ui/section-layout.tsx"

export const HeroWithTypographicReveal = ({
  heroText,
  p1Variant,
  taglineContent,
  className,
}: Props) => {
  const [showTagline, setShotTagline] = React.useState(false)

  const heroRef = useIntersection<HTMLDivElement>({
    onIntersect(entry) {
      if (!entry.isIntersecting && showTagline === false) {
        setShotTagline(true)
      }
    },
    options: {
      threshold: 0.333,
    },
  })

  return (
    <div className={UI.cx("relative h-[calc(100svh+100lvh)]", className)}>
      <SectionLayout
        ref={heroRef}
        size="fluid"
        theme="light"
        className="absolute top-0 z-10 left-0 h-svh w-full"
      >
        <div className="h-full flex items-center justify-center">
          <Hero text={heroText} p1Variant={p1Variant} />
        </div>
      </SectionLayout>

      <SectionLayout
        size="fluid"
        theme="light"
        className={UI.cx(
          "sticky top-0 h-lvh",
          "bg-white text-center",
          "border-b border-gray-3",
          "flex items-center justify-center",
        )}
      >
        {showTagline && <Tagline content={taglineContent} />}
      </SectionLayout>
    </div>
  )
}

export type P1Variant = "A" | "B" | "Custom"

type Props = UI.HTMLElementProps<{
  p1Variant: P1Variant
  taglineContent: TaglineContent[]
  heroText: string
}>
